import styled from 'styled-components';

export const PowerBIEmbedContainer = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
  height: 1000px;
  position: relative;
  border: 1px solid #CBCBCB;
  border-radius: 10px;
`;

export const PowerBIEmbedTitle = styled.span`
position: absolute;
padding-inline: 10px;
width: 100%;
height: 25px;
background-color: white;
z-index: 5;
border-bottom: 1px solid #CBCBCB;
`;
